import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import DateSelector from './DateSelector';

const DateRangeDropdown = ({
  name,
  value,
  optionsList,
  handleChange,
  toggleComponent,
  toggleClasses,
  drop,
  align,
  fullWidth,
}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const popperRef = useRef(null);

  // When dropdown opens, keep popper instance reference
  const handleToggle = (isOpen, e, metadata) => {
    setOpen(isOpen);
    if (metadata && metadata.popper) {
      popperRef.current = metadata.popper;
    }
  };

  // Reposition dropdown whenever its content changes
  useEffect(() => {
    if (!open) return; // Only run when dropdown is open
    setTimeout(() => {
      if (!menuRef.current) {
        // Still null after open
        return;
      }
      const ro = new ResizeObserver(() => {
        if (popperRef.current) {
          popperRef.current.update();
        }
      });
      ro.observe(menuRef.current);
      return () => ro.disconnect();
    }, 0);
  }, [open]);

  return (
    <div className='ticket-date-filter-custom-dropdown'>
      <Dropdown show={open} drop={drop ?? 'down'} autoClose={true} onToggle={handleToggle}>
        <Dropdown.Toggle
          id='date-range-toggle'
          variant='none'
          className={`rounded-sm cursor-pointer ${toggleClasses ?? ''}`}
          as='div'
        >
          {toggleComponent}
        </Dropdown.Toggle>
        <Dropdown.Menu
          ref={menuRef}
          className={`${fullWidth ? 'w-100' : ''}`}
          align={align ?? 'start'}
          as='div'
          popperConfig={{
            modifiers: [
              {
                name: 'captureInstance',
                enabled: true,
                phase: 'write',
                fn: ({ instance }) => {
                  popperRef.current = instance;
                },
              },
            ],
          }}
        >
          {open && (
            <DateSelector
              name={name}
              optionsList={optionsList}
              value={value ?? { type: '', range: [] }}
              handleChange={handleChange}
              handleClose={() => setOpen(false)}
            />
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

DateRangeDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  optionsList: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  toggleComponent: PropTypes.object.isRequired,
  toggleClasses: PropTypes.string,
  drop: PropTypes.string,
  align: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default DateRangeDropdown;
